"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = __importDefault(require("../../styles/theme"));
const typography_1 = require("../../styles/typography");
const date_utils_1 = __importDefault(require("../../lib/date-utils"));
const calendar_cell_1 = require("./calendar-cell");
const icon_1 = __importDefault(require("../icon"));
const styled_div_1 = __importDefault(require("../styled-div"));
/**
 *
 * See usage example in date-picker/date-picker.js file
 *
 * WARNING: Before changing this file, please strongly consider whether your change is
 * necessary (we want to avoid unexpected bugs in other views).
 * This code is meant to be shared by many views throughout our app and should not
 * contain logic specifc to how your view is using it.
 *
 */
const SelectRoot = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;

  position: relative;

  & + & {
    margin-left: 0.5rem;
  }
`;
const SelectElement = styled_components_1.default.select `
  ${typography_1.defaultText}

  appearance: none;
  cursor: pointer;
  background: none;
  border: none;
  padding-right: 18px;

  &:focus-visible {
    outline: ${(props) => props.theme.outline};
    outline-offset: 3px;
    border-radius: ${(props) => props.theme.borderRadius};
  }
`;
const StyledDropDownIcon = styled_components_1.default(icon_1.default) `
  pointer-events: none;
  position: absolute;
  right: 0;
`;
const StyledNextPrevButton = styled_components_1.default(calendar_cell_1.CellButton) `
  background: none;

  & + & {
    margin-left: 0.2rem;
  }
`;
const StyledNextPrevIcon = styled_components_1.default(icon_1.default) `
  vertical-align: middle;
`;
const CalendarSelect = ({ children, label, onChange, value, }) => (react_1.default.createElement(SelectRoot, null,
    react_1.default.createElement(SelectElement, { "aria-label": label, onChange: onChange, value: value }, children),
    react_1.default.createElement(StyledDropDownIcon, { color: theme_1.default.colors.textDefault, name: "keyboard_arrow_down", size: "18px" })));
const CalendarHeader = ({ viewingDate, onViewingDateChange, maxDate, minDate, locale = 'en', }) => {
    const YEARS_ARRAY = date_utils_1.default.getYearsRange(minDate, maxDate);
    const MONTHS_ARRAY = date_utils_1.default.getMonthsRange(viewingDate, minDate, maxDate);
    const prevMonth = () => {
        onViewingDateChange(date_utils_1.default.subMonth(viewingDate, minDate));
    };
    const nextMonth = () => {
        onViewingDateChange(date_utils_1.default.addMonth(viewingDate, maxDate));
    };
    return (react_1.default.createElement(styled_div_1.default, { flex: true, justifyContent: "space-between" },
        react_1.default.createElement(styled_div_1.default, { flex: true, justifyContent: "flex-start", paddingLeft: "s" },
            react_1.default.createElement(CalendarSelect, { label: "month", value: `${viewingDate.month}`, onChange: (e) => {
                    onViewingDateChange(Object.assign(Object.assign({}, viewingDate), { month: Number(e.target.value) }));
                } }, MONTHS_ARRAY.map((m) => (react_1.default.createElement("option", { key: m, value: m }, date_utils_1.default.getMonthName(m, locale))))),
            react_1.default.createElement(CalendarSelect, { label: "year", value: `${viewingDate.year}`, onChange: (e) => {
                    const yearSelected = Number(e.target.value);
                    const max = date_utils_1.default.getMomentAsObject(maxDate);
                    const min = date_utils_1.default.getMomentAsObject(minDate);
                    onViewingDateChange(Object.assign(Object.assign(Object.assign(Object.assign({}, viewingDate), (yearSelected === max.year &&
                        viewingDate.month > max.month && { month: max.month })), (yearSelected === min.year &&
                        viewingDate.month < min.month && { month: min.month })), { year: yearSelected }));
                } }, YEARS_ARRAY.map((y) => (react_1.default.createElement("option", { key: y, value: y }, y))))),
        react_1.default.createElement(styled_div_1.default, { flex: true, justifyContent: "flex-end", paddingRight: "xxs" },
            react_1.default.createElement(StyledNextPrevButton, { "aria-label": "previous", onClick: prevMonth },
                react_1.default.createElement(StyledNextPrevIcon, { name: "keyboard_arrow_left", color: theme_1.default.colors.textInput, size: "18px" })),
            react_1.default.createElement(StyledNextPrevButton, { "aria-label": "next", onClick: nextMonth },
                react_1.default.createElement(StyledNextPrevIcon, { name: "keyboard_arrow_right", color: theme_1.default.colors.textInput, size: "18px" })))));
};
exports.default = CalendarHeader;
